import { useMemo } from 'react';
import { IStudyDto } from '../../services/api/api-client';
import { ColumnDef } from '@tanstack/react-table';
import { linkButtonColumn } from 'uikit/table/columns/LinkButtonColumn';
import styles from './studies.module.scss';
import { ReactComponent as Chevron } from 'src/assets/img/patient/chevronPatientRow.svg';
import { navigateToRoute } from 'src/navigation/routes';

export const useGoToStudyButton = (): ColumnDef<IStudyDto> => {
  return useMemo(
    () =>
      linkButtonColumn({
        id: 'go-to-study-button',
        icon: Chevron,
        to: ({ row }) => navigateToRoute.dashboard(row.original.id),
        className: styles.goToStudyButton,
      }),
    [],
  );
};
